export default __webpack_public_path__ + "static/media/tab-content-image-02.210e1d6a.png";